import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_MAIL: GlameraIconDefinition = {
  name: 'mail',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-mail-group">
      <path
        class="glm-mail-flap"
        pathLength="24"
        d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7">
      </path>
      <rect class="glm-mail-body" x="2" y="4" width="20" height="16" rx="2"></rect>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-mail-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './mail.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MailIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_MAIL;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
